import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { toast } from "sonner";
import { AlertTriangle, CheckCircle2, Loader2 } from "lucide-react";

const ROLES = ["admin", "manager", "buchhaltung", "rechnung_pdf"];

// Hinweis „Rechnung ist Entwurf in sevDesk“ + „Rechnung fertigstellen“ (Status „Offen“, ohne E-Mail)
export const RechnungEntwurfBanner = ({ order, user, onChanged }) => {
  const [busy, setBusy] = useState(false);
  const fehler = order.rechnung_finalisierung_fehler;
  if (!order.sevdesk_rechnung_id || !(order.rechnung_entwurf || fehler)) return null;
  const finish = async () => {
    if (busy) return;
    setBusy(true);
    try {
      const r = await api.post(`/auftraege/${order.id}/rechnung/fertigstellen`, { send_type: "VPDF" });
      toast.success(r.data.bereits_offen ? `Rechnung ${r.data.rechnungsnummer} ist in sevDesk bereits „${r.data.label}“.` : `Rechnung ${r.data.rechnungsnummer} fertiggestellt (sevDesk: ${r.data.label}).`);
    } catch (e) { toast.error(e?.response?.data?.detail || "Rechnung konnte nicht fertiggestellt werden."); }
    finally { setBusy(false); onChanged?.(); }
  };
  return (
    <Card className="border-amber-300 bg-amber-50" data-testid="auftrag-rechnung-entwurf">
      <CardContent className="p-4 flex items-start gap-3 flex-wrap sm:flex-nowrap">
        <AlertTriangle className="w-5 h-5 text-amber-700 shrink-0 mt-0.5" />
        <div className="flex-1 text-sm text-amber-900 min-w-0">
          <div className="font-semibold">Rechnung ist Entwurf in sevDesk</div>
          <div>Rechnung <span className="font-mono">{order.rechnungsnummer}</span> ist noch nicht fertiggestellt – sie kann in sevDesk erst nach dem Fertigstellen (Status „Offen“) gebucht und einer Zahlung zugeordnet werden.</div>
          {fehler?.message && <div className="mt-1 text-rose-800" data-testid="auftrag-rechnung-finalisierung-fehler">{fehler.message}</div>}
        </div>
        {ROLES.includes(user?.rolle) && (
          <Button size="sm" onClick={finish} disabled={busy} className="bg-amber-600 hover:bg-amber-700 text-white shrink-0" data-testid="auftrag-rechnung-fertigstellen">
            {busy ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <CheckCircle2 className="w-4 h-4 mr-1" />} {busy ? "Wird fertiggestellt…" : "Rechnung fertigstellen"}
          </Button>
        )}
      </CardContent>
    </Card>
  );
};
